import { useState, useRef, useEffect } from 'react';

const API_URL = 'https://beta.api.dynamicwerx.com/AIChat/SendPrompt?prompt=';
const BEARER_TOKEN = sessionStorage.getItem('UserAuthToken');

const BOT_ICON =
  'data:image/jpeg;base64,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';

const AVATAR_COLORS = ['#7c3aed', '#0891b2', '#ea580c', '#16a34a', '#dc2626', '#d97706'];

function getGreeting() {
  const h = new Date().getHours();
  if (h >= 5 && h < 12) return 'Good morning';
  if (h >= 12 && h < 17) return 'Good afternoon';
  if (h >= 17 && h < 21) return 'Good evening';
  return 'Good night';
}

function formatTime(date) {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

function renderHtmlSafely(html) {
  return html
    .replace(/color\s*:\s*White/gi, '')
    .replace(/color\s*:\s*white/gi, '');
}

function initConversation() {
  return {
    id: 1,
    title: 'TMS Assistant',
    subtitle: 'AI-powered logistics support',
    messages: [
      {
        role: 'assistant',
        text: `Hi! ${getGreeting()} 👋 How can I help you today?`,
        time: formatTime(new Date())
      }
    ],
    unread: 0,
    lastMessage: `Hi! ${getGreeting()} 👋 How can I help you today?`,
    lastTime: formatTime(new Date())
  };
}

function ConvAvatar({ title, colorIdx }) {
  const initials = title
    .split(' ')
    .map(w => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
  return (
    <div
      style={{
        width: 42,
        height: 42,
        borderRadius: '50%',
        background: AVATAR_COLORS[colorIdx % AVATAR_COLORS.length],
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 14,
        fontWeight: 700,
        flexShrink: 0
      }}
    >
      {initials}
    </div>
  );
}

function BotAvatar({ small }) {
  const size = small ? 28 : 34;
  return (
    <img
      src={BOT_ICON}
      alt='AI'
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        objectFit: 'cover',
        flexShrink: 0
      }}
    />
  );
}

function UserAvatar({ small }) {
  const size = small ? 28 : 34;
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: '#1976d2',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: small ? 11 : 13,
        fontWeight: 700,
        flexShrink: 0
      }}
    >
      Y
    </div>
  );
}

function MessageBubble({ msg }) {
  const isUser = msg.role === 'user';
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isUser ? 'row-reverse' : 'row',
        gap: 8,
        alignItems: 'flex-end'
      }}
    >
      {isUser ? <UserAvatar small /> : <BotAvatar small />}
      <div
        style={{
          maxWidth: '70%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: isUser ? 'flex-end' : 'flex-start'
        }}
      >
        <span style={{ fontSize: 11, color: '#999', marginBottom: 3 }}>
          {isUser ? 'You' : 'TMS Assistant'}
        </span>
        <div
          style={{
            padding: '10px 14px',
            borderRadius: isUser ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
            background: isUser ? '#1976d2' : '#f0f0f0',
            color: isUser ? '#fff' : '#1a1a1a',
            fontSize: 13,
            lineHeight: 1.55,
            wordBreak: 'break-word'
          }}
        >
          {msg.isHtml ? (
            <div dangerouslySetInnerHTML={{ __html: renderHtmlSafely(msg.text) }} />
          ) : (
            msg.text.split('\n').map((line, i) => (
              <span key={i}>
                {line}
                <br />
              </span>
            ))
          )}
        </div>
        <span style={{ fontSize: 10, color: '#bbb', marginTop: 3 }}>
          {isUser ? '✓ ' : ''}
          {msg.time}
        </span>
      </div>
    </div>
  );
}

function TypingDots() {
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end' }}>
      <BotAvatar small />
      <div
        style={{
          padding: '10px 14px',
          background: '#f0f0f0',
          borderRadius: '18px 18px 18px 4px',
          display: 'flex',
          gap: 5,
          alignItems: 'center'
        }}
      >
        {[0, 1, 2].map(i => (
          <div
            key={i}
            style={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              background: '#bbb',
              animation: 'tmsBlink 1.2s infinite',
              animationDelay: `${i * 0.2}s`
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default function TMSChatWidget() {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [view, setView] = useState('home');
  const [conversations, setConversations] = useState([initConversation()]);
  const [activeId, setActiveId] = useState(null);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const [error, setError] = useState('');
  const timerRef = useRef(null);
  const messagesEndRef = useRef(null);
  const textareaRef = useRef(null);

  const activeConv = conversations.find(c => c.id === activeId);
  const totalUnread = conversations.reduce((sum, c) => sum + c.unread, 0);

  useEffect(() => {
    if (view === 'chat') {
      setTimeout(
        () => messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' }),
        80
      );
    }
  }, [view, activeId]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [activeConv?.messages?.length, loading]);

  useEffect(() => {
    if (view === 'chat' && textareaRef.current) {
      setTimeout(() => textareaRef.current?.focus(), 60);
    }
  }, [view, activeId]);

  useEffect(() => {
    if (loading) {
      setTimer(0);
      timerRef.current = setInterval(() => setTimer(t => t + 1), 1000);
    } else {
      clearInterval(timerRef.current);
    }
    return () => clearInterval(timerRef.current);
  }, [loading]);

  function openConversation(id) {
    setActiveId(id);
    setView('chat');
    setError('');
    setConversations(prev =>
      prev.map(c => (c.id === id ? { ...c, unread: 0 } : c))
    );
  }

  function startNewConversation() {
    const id = Date.now();
    const conv = {
      id,
      title: 'New conversation',
      subtitle: 'Ask us anything',
      messages: [
        {
          role: 'assistant',
          text: `Hi! ${getGreeting()} 👋 How can I help you today?`,
          time: formatTime(new Date())
        }
      ],
      unread: 0,
      lastMessage: 'New conversation',
      lastTime: formatTime(new Date())
    };
    setConversations(prev => [conv, ...prev]);
    openConversation(id);
  }

  function processResponse(data) {
    const msgs = [];
    if (!data?.data) return msgs;
    data.data.forEach(entry => {
      const role = (entry.role?.label || '').toLowerCase();
      if (!entry.items) return;
      entry.items.forEach(item => {
        if (item.$type === 'TextContent' && item.text && role === 'assistant') {
          msgs.push({
            role: 'assistant',
            text: item.text,
            isHtml: false,
            time: formatTime(new Date())
          });
        }
      });
    });
    return msgs;
  }

  async function sendMessage() {
    const text = input.trim();
    if (!text || loading || !activeId) return;
    const userMsg = {
      role: 'user',
      text,
      isHtml: false,
      time: formatTime(new Date())
    };
    setConversations(prev =>
      prev.map(c =>
        c.id === activeId
          ? {
              ...c,
              messages: [...c.messages, userMsg],
              lastMessage: text,
              lastTime: formatTime(new Date())
            }
          : c
      )
    );
    setInput('');
    setError('');
    setLoading(true);
    if (textareaRef.current) textareaRef.current.style.height = 'auto';
    try {
      const res = await fetch(`${API_URL}${encodeURIComponent(text)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${BEARER_TOKEN}`
        }
      });
      if (!res.ok) {
        const errText = await res.text();
        setError(`Error ${res.status}: ${errText.slice(0, 150)}`);
        return;
      }
      const data = await res.json();
      const newMsgs = processResponse(data);
      const lastText = newMsgs.filter(m => m.role === 'assistant').pop()?.text;
      setConversations(prev =>
        prev.map(c => {
          if (c.id !== activeId) return c;
          return {
            ...c,
            messages: [...c.messages, ...newMsgs],
            lastMessage: lastText || c.lastMessage,
            lastTime: formatTime(new Date())
          };
        })
      );
    } catch (err) {
      setError(`Network error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  }

  return (
    <>
      <style>{`
        @keyframes tmsBlink { 0%,80%,100%{opacity:.2} 40%{opacity:1} }
        @keyframes tmsSlideUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
        .tms-widget { animation: tmsSlideUp 0.22s ease; font-family: system-ui, -apple-system, sans-serif; }
        .tms-conv-row:hover { background: #f5f7ff !important; }
        .tms-textarea:focus { outline: none; }
        .tms-send-btn:hover:not(:disabled) { background: #1565c0 !important; }
        .tms-fab:hover { transform: scale(1.08); }
        .tms-messages::-webkit-scrollbar { width: 4px; }
        .tms-messages::-webkit-scrollbar-thumb { background: #ddd; border-radius: 4px; }
      `}</style>

      {open && (
        <div
          className='tms-widget'
          style={{
            position: 'fixed',
            bottom: 55,
            right: 15,
            zIndex: 9999,
            width: expanded ? 500 : 370,
            height: expanded ? 'calc(100vh - 30px)' : 600,
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 18,
            overflow: 'hidden',
            boxShadow: '0 12px 48px rgba(0,0,0,0.22)'
          }}
        >
          {view === 'home' ? (
            /* ── HOME VIEW ── */
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                background: '#eef2f8'
              }}
            >
              {/* Blue gradient header */}
              <div
                style={{
                  background: 'linear-gradient(135deg, #1565c0 0%, #1976d2 100%)',
                  padding: '20px 20px 52px',
                  flexShrink: 0
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 6 }}
                  >
                    <div
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        background: '#4caf50'
                      }}
                    />
                    <span
                      style={{ color: '#fff', fontWeight: 600, fontSize: 14 }}
                    >
                      TMS Assistant
                    </span>
                  </div>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button
                      onClick={() => setExpanded(e => !e)}
                      title={expanded ? 'Collapse' : 'Expand'}
                      style={{
                        width: 28,
                        height: 28,
                        borderRadius: '50%',
                        background: 'rgba(255,255,255,0.2)',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {expanded ? (
                        <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
                          <polyline points='4 14 10 14 10 20' />
                          <polyline points='20 10 14 10 14 4' />
                          <line x1='10' y1='14' x2='21' y2='3' />
                          <line x1='3' y1='21' x2='14' y2='10' />
                        </svg>
                      ) : (
                        <svg width='13' height='13' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
                          <polyline points='15 3 21 3 21 9' />
                          <polyline points='9 21 3 21 3 15' />
                          <line x1='21' y1='3' x2='14' y2='10' />
                          <line x1='3' y1='21' x2='10' y2='14' />
                        </svg>
                      )}
                    </button>
                    <button
                      onClick={() => setOpen(false)}
                      style={{
                        width: 28,
                        height: 28,
                        borderRadius: '50%',
                        background: 'rgba(255,255,255,0.2)',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg
                        width='13'
                        height='13'
                        viewBox='0 0 24 24'
                        fill='none'
                        stroke='currentColor'
                        strokeWidth='2.5'
                        strokeLinecap='round'
                      >
                        <line x1='18' y1='6' x2='6' y2='18' />
                        <line x1='6' y1='6' x2='18' y2='18' />
                      </svg>
                    </button>
                  </div>
                </div>
                <h2
                  style={{
                    color: '#fff',
                    margin: '18px 0 6px',
                    fontSize: 22,
                    fontWeight: 700
                  }}
                >
                  Hi there. How can we help?
                </h2>
                <p
                  style={{
                    color: 'rgba(255,255,255,0.82)',
                    margin: 0,
                    fontSize: 13
                  }}
                >
                  We typically reply in a few minutes
                </p>
              </div>

              {/* Conversation list card — overlaps header */}
              <div
                style={{
                  background: '#fff',
                  borderRadius: 16,
                  margin: '-32px 12px 0',
                  boxShadow: '0 2px 16px rgba(0,0,0,0.1)',
                  flex: 1,
                  overflowY: 'auto',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {conversations.map((conv, idx) => (
                  <div
                    key={conv.id}
                    className='tms-conv-row'
                    onClick={() => openConversation(conv.id)}
                    style={{
                      display: 'flex',
                      gap: 12,
                      padding: '14px 16px',
                      cursor: 'pointer',
                      borderBottom: '1px solid #f2f2f2',
                      background: '#fff',
                      alignItems: 'center',
                      transition: 'background 0.15s'
                    }}
                  >
                    <ConvAvatar title={conv.title} colorIdx={idx} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}
                      >
                        <span
                          style={{
                            fontWeight: 600,
                            fontSize: 14,
                            color: '#1a1a1a'
                          }}
                        >
                          {conv.title}
                        </span>
                        <span
                          style={{
                            fontSize: 11,
                            color: '#999',
                            flexShrink: 0,
                            marginLeft: 8
                          }}
                        >
                          {conv.lastTime}
                        </span>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginTop: 3
                        }}
                      >
                        <span
                          style={{
                            fontSize: 12,
                            color: '#888',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            maxWidth: '85%'
                          }}
                        >
                          {conv.lastMessage}
                        </span>
                        {conv.unread > 0 && (
                          <div
                            style={{
                              width: 20,
                              height: 20,
                              borderRadius: '50%',
                              background: '#1976d2',
                              color: '#fff',
                              fontSize: 10,
                              fontWeight: 700,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              flexShrink: 0
                            }}
                          >
                            {conv.unread}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Ask a question button */}
              <div
                style={{ padding: '12px 16px 16px', flexShrink: 0 }}
              >
                <button
                  onClick={startNewConversation}
                  style={{
                    width: '100%',
                    padding: '13px',
                    borderRadius: 30,
                    background: '#1976d2',
                    color: '#fff',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: 600,
                    fontSize: 14,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 8,
                    boxShadow: '0 2px 8px rgba(25,118,210,0.35)'
                  }}
                >
                  Ask a question
                  <svg
                    width='16'
                    height='16'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <circle cx='12' cy='12' r='10' />
                    <path d='M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3' />
                    <line x1='12' y1='17' x2='12.01' y2='17' />
                  </svg>
                </button>
              </div>
            </div>
          ) : (
            /* ── CHAT VIEW ── */
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                background: '#fff'
              }}
            >
              {/* Header */}
              <div
                style={{
                  padding: '12px 14px',
                  borderBottom: '1px solid #eee',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  flexShrink: 0,
                  background: '#fff'
                }}
              >
                <button
                  onClick={() => setView('home')}
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    background: '#f5f5f5',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#444',
                    flexShrink: 0
                  }}
                >
                  <svg
                    width='14'
                    height='14'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <polyline points='15 18 9 12 15 6' />
                  </svg>
                </button>
                <div style={{ flex: 1 }}>
                  <div
                    style={{ fontWeight: 600, fontSize: 14, color: '#1a1a1a' }}
                  >
                    {activeConv?.title}
                  </div>
                  <div style={{ fontSize: 11, color: '#999' }}>
                    {activeConv?.subtitle}
                  </div>
                </div>
                <button
                  onClick={() => setExpanded(e => !e)}
                  title={expanded ? 'Collapse' : 'Expand'}
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    background: '#f5f5f5',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#444',
                    flexShrink: 0
                  }}
                >
                  {expanded ? (
                    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
                      <polyline points='4 14 10 14 10 20' />
                      <polyline points='20 10 14 10 14 4' />
                      <line x1='10' y1='14' x2='21' y2='3' />
                      <line x1='3' y1='21' x2='14' y2='10' />
                    </svg>
                  ) : (
                    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
                      <polyline points='15 3 21 3 21 9' />
                      <polyline points='9 21 3 21 3 15' />
                      <line x1='21' y1='3' x2='14' y2='10' />
                      <line x1='3' y1='21' x2='10' y2='14' />
                    </svg>
                  )}
                </button>
              </div>

              {/* Messages */}
              <div
                className='tms-messages'
                style={{
                  flex: 1,
                  overflowY: 'auto',
                  padding: '16px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 14
                }}
              >
                {activeConv?.messages.map((msg, i) => (
                  <MessageBubble key={i} msg={msg} />
                ))}
                {loading && <TypingDots />}
                {loading && (
                  <div
                    style={{ fontSize: 11, color: '#aaa', textAlign: 'center' }}
                  >
                    {timer}s
                  </div>
                )}
                {error && (
                  <div
                    style={{
                      fontSize: 12,
                      color: '#a32d2d',
                      background: '#fcebeb',
                      border: '0.5px solid #f09595',
                      borderRadius: 8,
                      padding: '6px 10px'
                    }}
                  >
                    {error}
                  </div>
                )}
                <div ref={messagesEndRef} />
              </div>

              {/* Input bar */}
              <div
                style={{
                  padding: '10px 12px',
                  borderTop: '1px solid #eee',
                  display: 'flex',
                  gap: 8,
                  alignItems: 'flex-end',
                  background: '#fff',
                  flexShrink: 0
                }}
              >
                {/* attachment icon placeholder */}
                <button
                  style={{
                    width: 34,
                    height: 34,
                    borderRadius: '50%',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#ccc',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}
                >
                  <svg
                    width='18'
                    height='18'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path d='M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48' />
                  </svg>
                </button>
                <textarea
                  ref={textareaRef}
                  className='tms-textarea'
                  rows={1}
                  value={input}
                  onChange={e => {
                    setInput(e.target.value);
                    e.target.style.height = 'auto';
                    e.target.style.height =
                      Math.min(e.target.scrollHeight, 100) + 'px';
                  }}
                  onKeyDown={handleKeyDown}
                  placeholder='Type a message'
                  style={{
                    flex: 1,
                    padding: '8px 0',
                    fontSize: 13,
                    border: 'none',
                    fontFamily: 'inherit',
                    lineHeight: 1.5,
                    maxHeight: 100,
                    overflow: 'auto',
                    resize: 'none',
                    background: 'transparent',
                    color: '#1a1a1a'
                  }}
                />
                <button
                  className='tms-send-btn'
                  onClick={sendMessage}
                  disabled={loading || !input.trim()}
                  style={{
                    width: 36,
                    height: 36,
                    borderRadius: '50%',
                    background:
                      loading || !input.trim() ? '#c8d9f0' : '#1976d2',
                    border: 'none',
                    cursor:
                      loading || !input.trim() ? 'default' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    flexShrink: 0,
                    transition: 'background 0.15s'
                  }}
                >
                  <svg
                    width='16'
                    height='16'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='2.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <line x1='22' y1='2' x2='11' y2='13' />
                    <polygon points='22 2 15 22 11 13 2 9 22 2' />
                  </svg>
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* FAB */}
      {!open && (
        <button
          className='tms-fab'
          onClick={() => setOpen(true)}
          style={{
            position: 'fixed',
            bottom: 55,
            right: 15,
            zIndex: 9999,
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: '#1976d2',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 20px rgba(25,118,210,0.5)',
            transition: 'transform 0.15s, box-shadow 0.15s'
          }}
        >
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            stroke='#fff'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' />
          </svg>
          {totalUnread > 0 && (
            <div
              style={{
                position: 'absolute',
                top: 3,
                right: 3,
                width: 18,
                height: 18,
                borderRadius: '50%',
                background: '#e24b4a',
                color: '#fff',
                fontSize: 10,
                fontWeight: 700,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '2px solid #fff'
              }}
            >
              {totalUnread}
            </div>
          )}
        </button>
      )}
    </>
  );
}
